import { render, staticRenderFns } from "./billingProfessionalTransfer.vue?vue&type=template&id=3d968eb8"
import script from "./billingProfessionalTransfer.vue?vue&type=script&lang=js"
export * from "./billingProfessionalTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports